var React = require('react');

function Creditcard (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M15.3149 1.48855C15.9116 1.48855 16.4088 1.98473 16.4088 2.58015V10.4198C16.4088 11.0153 15.9116 11.5115 15.3149 11.5115H2.58563C1.98895 11.5115 1.49171 11.0153 1.49171 10.4198V2.58015C1.49171 1.98473 1.98895 1.48855 2.58563 1.48855H15.3149ZM15.3149 0H2.58563C1.09392 0 0 1.0916 0 2.58015V10.4198C0 11.8092 1.09392 13 2.58563 13H15.4144C16.8066 13 18 11.9084 18 10.4198V2.58015C17.9006 1.0916 16.8066 0 15.3149 0Z","fill":"#FFD25D","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M17 5.75H1V4.25H17V5.75Z","fill":"#FFD25D","key":1}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M15 9.75H10V8.25H15V9.75Z","fill":"#FFD25D","key":2})]);
}

Creditcard.defaultProps = {"width":"18","height":"13","viewBox":"0 0 18 13","fill":"none"};

module.exports = Creditcard;

Creditcard.default = Creditcard;
